import type React from 'react';

import type { IconProps } from 'types/icon';

const ChevronDown: React.FC<IconProps> = ({
  size = '16',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M18.9862 8.57793C19.2357 8.82748 19.2357 9.2319 18.9862 9.48145L12.2948 16.1734L5.59692 9.48203C5.34726 9.23261 5.34691 8.82759 5.59634 8.57793C5.84569 8.3284 6.25019 8.32818 6.49985 8.57734L12.2942 14.3658L18.0827 8.57793C18.3322 8.32839 18.7366 8.32839 18.9862 8.57793Z"
        fill={color}
      />
    </svg>
  );
};

export default ChevronDown;
